/*
 * @Author: LZH
 * @Date: 2023-04-03 10:43:52
 * @LastEditors: Do not edit
 * @LastEditTime: 2026-02-02 17:33:42
 * @Description:
 */
import message from './message/fn';
import placeholder from './placeholder/fn';
let NODE_ENV = window.XINPOC_WEB_CONFIG.isProject;
let title = {
  globalpoc:"Globalpoc",
  hpyj:"Shenzhen Haopan Yijia Technology Co., Ltd.",
};
export default {
  language: {
    name: '中文',
    title: 'Langue',
  },
  about: {
    title: title[NODE_ENV] || 'Xin POC',
    conpanyname: 'Shenzhen Bonard Information Technology Co., Ltd.',
    beian: "Numéro d'enregistrement du site web",
    icp: 'Guangdong ICP No. 16086702',
    copyright: 'Copyright : Shenzhen Bonard Information Technology Co., Ltd. Version No. : v2.0.7 Copyright © 2021-2022'
  },
  login: {

    tag: {
      agent: 'Agent',
      company: 'Entreprise'
    },

    placeholder: {
      account: 'Veuillez entrer le compte de connexion',
      password: 'Veuillez saisir le mot de passe de connexion'
    },

    button: {
      login: ' se connecter',
      remember: ' Vous vous souvenez du numéro de compte ?'
    },

    tips: {
      empty: 'Le compte ou le mot de passe ne peut pas être vide',
      not_account: "Le compte n'existe pas",
      err_password: 'Erreur de mot de passe',
      completethepuzzle: 'Faites glisser le curseur ci-dessous pour terminer le puzzle',
      Verificationissuccessful: 'La vérification est réussie',
      Verificationerrorpleasetryagain: 'Erreur de vérification, veuillez réessayer'
    }
  },
  from: {  //表单
    icon: 'avatar',
    Agent_name: " Nom de l'agent",
    Account: 'compte de connexion',
    Contact_name: 'Nom du contact',
    mobile: 'Numéro de téléphone portable',
    uName: 'Nom',
    recharge_contact: 'Coordonnées pour la recharge',
    Select_Address: "Sélectionnez l'adresse",
    Detailed_address: 'Adresse détaillée',
    Not_filled_in: 'non rempli',
    contact_information: 'Coordonnées',
    area: 'zone',
    Reset_Password: 'Réinitialiser le mot de passe'
  },
  placeholder: {
    ...placeholder
  },
  message: { //提示
    ...message
  },
  but: {   //按钮
    send_out: 'envoyer',
    preserve: 'Sauvegarder',
    confirm: 'confirmer',
    define: "D'ACCORD",
    next: 'Suivant'
  },

  agent: {
    Agency_account: "Compte d'agence",
    Contact_information: 'Coordonnées',
    Please_enter_agentname: "Veuillez saisir le nom de l'agent",
    agentname_required: '(obligatoire : 4 à 20 caractères lettres chiffres)',
    Please_enter_loginAccount: 'Veuillez entrer le compte de connexion',
    loginAccount_required: ' (obligatoire : 6 à 20 lettres chiffres)',
    Please_enter_loginPassword: 'Veuillez saisir le mot de passe de connexion',
    loginPassword_required: '(obligatoire : 6 à 16 chiffres)',
    Please_enter_contactname: 'Veuillez saisir le nom du contact',
    contactname_required: '(obligatoire : 2 à 20 caractères lettres chiffres)',
    Please_enter_address: "Veuillez saisir l'adresse détaillée de l'agent",
    address_optional: '(facultatif)',
    search_agent: 'Agent de recherche',
    recover_integer: 'Le nombre de cartes de service récupérées doit être un entier',
    recover_num: 'Le nombre de cartes de service récupérées doit être un entier'
  },

  navigation: {
    personal_center: 'Centre personnel',
    search: 'Recherche',
    my_agent: 'Mon agent',
    agent_list: 'Liste des agents',
    create_agent: 'Créer un agent',

    my_company: 'Mon entreprise',
    company_list: 'Liste des entreprises',
    create_company: 'Créer une entreprise',

    my_group: 'Mon groupe',
    group_list: 'liste de groupe',
    create_group: 'Créer un groupe',

    my_user: 'Mon utilisateur',
    user_list: 'Liste des utilisateurs',
    create_user: 'Créer un utilisateur',

    news_notice: "Notification d'actualités",
    Scanning_code_found: 'Numériser pour créer',

    function_card_sell: 'Vente de cartes de service',
    function_card_record: 'Dossier de carte de service',
    system_annoucement: 'Annonce du système',

    my_bounding: 'Ma clôture',
    bounding_list: 'Liste de délimitation',
    create_bounding: 'Créer une clôture',

    recording_record: "enregistrement d'enregistrement",
    sos_record: 'Enregistrement SOS',
    broadcast_record: 'Enregistrement de diffusion',
    Agent_details: "Détails de l'agent",
    Scancodetocreate: 'Scannez le code pour créer',
    Createuserinformation: 'Créer des informations utilisateur',
    Confirmdetails: 'Confirmer les détails',
    EditOrganizationInformation: "Modifier les informations de l'entreprise",
    notificationreminder: 'Rappel de notification',
    selectgroup: 'groupe de sélection',
    edituserinformation: 'modifier les informations utilisateur',
    Userreplacementcard: 'Carte de remplacement utilisateur',
    completematerial: 'matériel complet',
    choosehost: 'Choisissez un seul haut-parleur (les autres sont muets)',
    Selectagrouptolistento: 'Sélectionnez un groupe à écouter',
    Terminalrenewaldetails: 'Détails du renouvellement du terminal',
    managementplatform: 'Plateforme de gestion',
    electricfence: 'clôture électrique',
    Electronicfencerecords: 'Registres de clôture électroniques',
    Registeraccount: "Enregistrement du compte",
    Boundcompanyusers:"Utilisateurs liés",
    Unboundcompanyusers:"Utilisateurs non liés",
    Listofboundcompanyusers:'Liste des utilisateurs liés',
    Listofunboundcompanyusers:'Liste des utilisateurs non liés'
  },

  setup: {
    setup: 'Installation',
    Change_Password: 'Changer le mot de passe',
    user_information: 'informations personnelles',
    Reset_Login_Password: 'Réinitialiser le mot de passe de connexion',
    Modify_payment_password: 'Modifier le mot de passe de paiement',
    about: 'à propos',
    Problem_feedback: 'Commentaires sur les problèmes',
    Verify_phone: ' Vérifier le téléphone',
    Set_payment_password: 'Définir le mot de passe de paiement'
  },

  org: {
    org_name: "Nom de l'entreprise",
    createCompany: 'Nouvelle entreprise',
    UnitAccount: "Compte d'entreprise",
    createGroups: 'Créez 16 groupes en même temps',
    plGroups: 'Le suffixe du nom du groupe de lots plus le nombre naturel répété continue le nombre naturel'
  },
  consume: 'consommer',
  area: 'zone',
  logout: 'déconnexion',
  VerifyPC: 'Ouvrir le lien sur PC',
  // connect: 'Exception de connexion au serveur',
  connect: 'Chargement...',
  existing: 'Existant',
  individual: 'un',
  Quantityis: 'La quantité est 0 et ne peut pas être récupérée',
  Withdrawal_quantity: 'La quantité retirée ne peut pas être supérieure à la quantité existante',
  click_load: 'Cliquez pour charger plus',
  refresh_successfully: 'Actualiser avec succès',
  search: 'Recherche',
  detail: 'Détails',
  edit: 'modifier',
  delete: 'Supprimer',
  confirm: "D'ACCORD",
  cancel: 'Annuler',
  call_back: 'retour',
  time: 'temps',
  category: 'catégorie',
  title: 'Titre',
  data: 'date',
  starting_date: 'date de début',
  ending_date: 'date de fin',
  starting_time: 'période de départ',
  ending_time: 'Fin de période',
  type: 'Taper',
  please_select: 'Veuillez sélectionner',
  content: 'Contenu',
  notice: 'Avis',
  tuneto_agent: "Accordez-vous à l'agent",
  beingTransferred_agent: 'Agent transféré',
  thefence: 'clôture',
  member: 'Membre',
  users: 'utilisateur',
  searchuser: 'rechercher un utilisateur',
  group: 'groupe',
  searchgroup: 'groupe de recherche',
  company: 'entreprise',
  searchunit: 'entreprise de recherche',
  agent_name: 'Agent',
  prefixnickname: 'préfixe surnom',
  user_name: "Nom d'utilisateur",
  company_name: 'Société affiliée',
  user_info: 'Informations utilisateur',
  sale: 'vente',
  create_user: 'Créer un utilisateur',
  start_service: 'Service ouvert',
  recycle_recycled: 'recyclé/recyclé',
  delete_users: 'Supprimer les utilisateurs',
  deletequantity: 'supprimer la quantité',
  purchasement: 'Achat',
  change_agents: 'Agents de changement',
  voice: 'Voix',
  recording: 'enregistrement',
  position: 'positionnement',
  thefence: 'clôture',
  video: 'vidéo',
  recycle: 'Recycler',
  recycled: 'recyclé',
  card_type: 'Type de carte de service',
  card_type1: 'Type de carte de service',
  select_card_type: 'Sélectionnez le type de carte de service',
  card_number: 'Nombre de cartes de service',
  ptt_card: 'carte vocale',
  recording_card: "Carte d'enregistrement",
  gps_card: 'carte de localisation',
  sos_card: 'carte SOS',
  bounding_card: 'Carte de délimitation',
  video_card: 'carte vidéo',
  duplex_card: 'Carte duplex',
  vipcard: 'carte VIP',
  ptt_card_sale: 'Vente de cartes vocales',
  recording_card_sale: "Vente de cartes d'enregistrement",
  gps_card_sale: 'Vente de cartes de localisation',
  sos_card_sale: 'Vente de cartes SOS',
  bounding_card_sale: 'Vente de cartes SOS',
  video_card_sale: 'Vente de cartes vidéo',
  Duplexcardsales: 'Vente de cartes duplex',
  vipcardsales: 'Vente de cartes VIP',
  pttgpssales: 'Ventes PTT+GPS',
  usevoicecard: 'Utiliser la carte vocale',
  userecordingcard: "utiliser une carte d'enregistrement",
  uselocatorcard: 'Utiliser la carte de localisation',
  useSOScard: 'Utiliser la carte SOS',
  usefencecard: 'Utiliser la carte de clôture',
  usevideocard: 'utiliser une carte vidéo',
  Useaduplexcard: 'Utiliser une carte duplex',
  usepttgps: 'Utilisation de PTT+GPS',
  usevipcard: ' Utiliser la carte VIP',
  voiceservicecard: 'carte de service vocal',
  recordingservicecard: "carte de service d'enregistrement",
  locationservicecard: 'carte de service de localisation',
  SOSservicecard: 'Carte de service SOS',
  fenceservicecard: 'carte de service de clôture',
  videoservicecard: 'Carte de service vidéo',
  Dualservicecard: 'Carte de service double',
  vipservicecard: 'Carte de service VIP',
  voiceservice: 'Voix',
  recordingservice: "service d'enregistrement",
  locationservice: 'service de localisation',
  SOSservice: 'service SOS',
  fenceservice: 'service de clôture',
  videoservice: 'Service vidéo',
  duplexservice: 'Service duplex',
  recordingcardrecycling: "Recyclage des cartes d'enregistrement",
  LocationCardRecycling: 'Recyclage des cartes de localisation',
  SOSCardRecycling: 'Recyclage des cartes de localisation',
  FenceCardRecycling: 'Recyclage des cartes de clôture',
  videocardrecycling: 'Recyclage des cartes vidéo',
  Duplexcardrecycling: 'Recyclage des cartes duplex',
  VoiceFeatureNotification: 'Recyclage des cartes duplex',
  Notificationofrecordingfunction: "notification de la fonction d'enregistrement",
  Positioningfeaturenotification: 'Notification de fonction de positionnement',
  SOSfunctionnotification: 'Notification de la fonction SOS',
  Fencefeaturenotification: 'Notification de fonctionnalité de clôture',
  VideoFeatureNotification: 'Notification de fonctionnalité vidéo',
  DuplexFeatureNotification: 'Notification de la fonction duplex',
  PTTGPSFeatureNotification: 'Notifications de la fonctionnalité PTT+GPS',
  automatically: 'Supprimer automatiquement les notifications des utilisateurs de test',
  DeleteExpired: "Supprimer la notification d'utilisateur expiré",
  remained: 'Équilibre',
  pieces: 'morceau',
  residue: 'résiduel',
  recycle_successfully: 'Recycler avec succès',
  None_record: "Pas encore d'enregistrement",
  this_month: 'ce mois-ci',
  Year: 'Année',
  moon: 'mois',
  day: 'mois',
  weekly1: 'Lundi',
  weekly2: 'Mardi',
  weekly3: 'Mercredi',
  weekly4: 'Jeudi',
  weekly5: 'Vendredi',
  weekly6: 'Samedi',
  weekly7: 'Dimanche',
  submit: 'Soumettre',
  modify_successfully: 'Modifié avec succès',
  confirm1: 'Confirmer',
  lumpsum: 'total',
  selltoagents: 'vendre à des agents',
  nametips: "Le pseudo d'entrée est simplement le préfixe du pseudo de l'utilisateur et le suffixe est distingué par un nombre naturel en fonction du nombre d'utilisateurs que vous avez créés. Par exemple : le surnom que vous avez saisi est",
  nametips2: 'Les surnoms des deux utilisateurs que vous avez créés sont',
  nametips3: 'La prochaine fois',
  nametips4: "Pour le surnom préfixé, le nom d'utilisateur sera étendu à",
  nametips5: 'attendez',
  IMEIscancodetoadd: 'Code de numérisation IMEI à ajouter',
  IMEIinputadded: 'Entrée IMEI ajoutée',
  IMEIinputaddedtocreate: "Entrée IMEI ajoutée pour créer jusqu'à 10 utilisateurs",
  Starttherecordingservice: "Démarrer le service d'enregistrement",
  Turnonlocationservices: 'Activer les services de localisation',
  EnableSOSservice: 'Activer le service SOS',
  Startfenceservice: 'Démarrer le service de clôture',
  Turnondualservice: 'Activer le double service',
  Turnonthevideoservice: 'Activer le service vidéo',
  Usercomments: 'Commentaires des utilisateurs',
  Agentnote: "Note de l'agent",
  total: 'total',
  settlement: 'Règlement',
  hint: 'indice',
  Areyousuretoremove: 'Êtes-vous sûr de vouloir supprimer ?',
  Areyousuretoclearall: 'Êtes-vous sûr de tout effacer ?',
  cocreated: 'co-créé',
  accountssubtotal: 'sous-total des comptes',
  Scancodeentryarea: 'Zone de saisie du code de numérisation',
  empty: 'vide',
  none: 'aucun',
  Second: 'secondes',
  Salesvolume: 'Volume des ventes',
  Purchasequantity: "Quantité d'achat",
  returnquantity: 'quantité de retour',
  Recoveredquantity: 'quantité récupérée',
  returnquantity2: 'quantité de retour',
  setasdefaultgroup: 'Définir comme groupe par défaut',
  newgroup: 'Nouveau groupe',
  groupname: 'nom du groupe',
  selected: 'choisi',
  groups: 'groupes',
  allgroups: 'tous les groupes',
  Groupduration: 'Durée du groupe',
  calltime: "heure d'appel",
  groupmembers: 'membres du groupe',
  Modifygroupname: 'Modifier le nom du groupe',
  priority: 'priorité',
  remove: 'retirer',
  addmembers: 'Ajouter des membres',
  levelone: 'niveau 1',
  Secondary: 'niveau 2',
  Levelthree: 'niveau 3',
  Levelfour: 'niveau 4',
  Fifthgrade: 'niveau 5',
  OKtoadd: 'OK pour ajouter',
  reenter: 'rentrer',
  Setdigitservicecardpassword: 'Définir un mot de passe de carte de service à 6 chiffres',
  Enteragaintoconfirm: 'Entrez à nouveau pour confirmer',
  Enterthedigitservicecardpassword: 'Entrez à nouveau pour confirmer',
  consumptioncard: 'carte de consommation',
  ConsumeSOScard: 'Consommer la carte SOS',
  Consumefencecard: 'Carte de consommation',
  Consumptionrecordingcard: "Carte d'enregistrement de la consommation",
  Consumeduplexcard: 'Carte de consommateur',
  Consumptionvideocard: 'Consommation de la carte vidéo',
  account: 'compte',
  unfilled: 'non rempli',
  contactnumber: 'numéro de contact',
  emailaddress: 'Adresse email',
  mailingaddress: 'adresse postale',
  Belonginggroup: "Groupe d'appartenance",
  Nickname: "Nom d'utilisateur",
  suspendaccount: 'Compte',
  unitdispatcher: "Répartiteur de l'entreprise",
  dispatcher: 'répartiteur',
  basestationpositioning: 'Positionnement de la station de base',
  GPSlocation: 'localisation GPS',
  positioninginterval: 'intervalle de positionnement',
  videocall: 'appel vidéo',
  strongpullvideo: 'Vidéo de traction forte',
  videoreturn: 'Retour vidéo',
  Numberchangeperiod: 'Période de changement de numéro',
  UsersNickname: "Pseudo de l'utilisateur",
  volumeactivation: 'Activation par lots',
  batchselection: 'sélection par lots',
  searchhistory: 'Historique de recherche',
  returnnotice: 'notification de retour',
  Notificationofbeingwithdrawn: 'Notification de retrait',
  takebacknotice: 'avis de reprise',
  bouncenotification: 'Notification de rebond',
  Notificationofbeingreturned: 'Notification de retour',
  Createusernotification: 'Créer une notification utilisateur',
  purchasenotice: "Notification d'achat",
  salereminder: 'rappel de vente',
  today: "aujourd'hui",
  yesterday: 'Hier',
  thedaybeforeyesterday: 'avant-hier',
  OriginalIMEI: "IMEI d'origine",
  NewIMEI: 'Nouveau IMEI',
  replace: 'remplacer',
  verificationcode: 'le code de vérification',
  resendverificationcode: 'renvoyer le code de vérification',
  back: 'dos',
  host: 'un seul haut-parleur (les autres sont muets)',
  listeninggroup: "Groupe d'écoute",
  Addlisteninggroup: "Ajouter un groupe d'écoute",
  Nodata: 'Aucune donnée',
  Corenewal: 'Frais de renouvellement totaux',
  Accountssubtotal: 'sous-total des comptes',
  Confirmrenewal: 'Confirmer le renouvellement',
  add_groupname_tips: 'Ajoutez un nombre naturel au suffixe du nom du groupe de lots et continuez le nombre naturel pour les noms répétés',
  Dataloadingcomplete: 'Chargement des données terminé',
  Usercreatedgroups: 'Groupes créés par les utilisateurs',
  Lord: 'Chef de groupe',
  chooseagroupleader: 'Choisissez un chef de groupe',
  alluser: 'tous les utilisateurs',
  SOSalarmsintemporarygroupsarenotrecorded: 'Les alarmes SOS dans les groupes temporaires ne sont pas enregistrées.',
  username: "nom d'utilisateur",
  startingtime: 'heure de début',
  Processor: 'Processeur',
  processtime: 'temps de traitement',
  Unprocessed: 'Non transformé',
  Processed: 'Traité',
  deleted: 'supprimé',
  name: 'nom',
  address: 'adresse',
  Warmreminder: "Rappel chaleureux : les données proviennent d'un tiers et peuvent contenir des erreurs. Ceci est à titre indicatif uniquement.",
  SOSlocation: 'Localisation SOS',
  permanent: 'permanent',
  Latitudeandlongitude: 'Latitude et longitude',
  Reportingtime: 'Heure du rapport',
  Positioningtime: 'Temps de positionnement',
  op1: 'SUR',
  op2: 'DÉSACTIVÉ',
  groupban: 'Interdiction de groupe',
  setptt: 'Définir la période de service PTT',
  Determinethemodification: 'Déterminer la modification',
  Onemonth: 'Un mois',
  Threemonths: 'Trois mois',
  Halfayear: 'Une demi-année',
  Expiredate: "Date d'expiration",
  year1: 'Un an',
  year2: 'Deux ans',
  year3: 'Trois ans',
  Sun: 'Soleil',
  Mon: 'Lun',
  Tue: 'Mar',
  Wed: 'Épouser',
  Thu: 'Jeu',
  Fri: 'Ven',
  Sat: 'Assis',
  Membermanagement: 'Gestion des membres',
  Validpermanently: 'Valable en permanence',
  Enteralarm: "Entrer l'alarme",
  Leavealarm: 'Laisser une alarme',
  repeat: 'répéter',
  Updatefence: 'Mettre à jour la clôture',
  Triggermode: 'Mode de déclenchement',
  Validperiod: 'Période de validité',
  start: 'commencer',
  end: 'fin',
  Validdate: 'Date de validité',
  fencekeeper: 'gardien de clôture',
  Membermanagement: 'Gestion des membres',
  fencename: 'nom de la clôture',
  Editfence: 'Modifier la clôture',
  Setupafencemanager: 'Mettre en place un gestionnaire de clôture',
  Fencedetails: 'Détails de la clôture',
  Currentoutofboundsrecord: 'Record actuel hors limites',
  Historicalcrossborderrecords: 'Documents historiques transfrontaliers',
  Allfences: 'Toutes les clôtures',
  Triggertime: 'Heure de déclenchement',
  Releasetime: 'Heure de sortie',
  NoExit: 'Sans issue',
  NoEntry: 'Entrée interdite',
  Recordinglist: "Liste d'enregistrement",
  temporarygroup: 'groupe temporaire',
  Voicelicensetype: 'Type de licence vocale',
  Voicelicensetime: 'Durée de la licence vocale',
  UTCtimeTips: "L'heure d'expiration est l'heure UTC",
  Determinethereplacement: 'Déterminer le remplacement',
  Regionalreplacement: 'Remplacement régional',
  Recoverypassword: 'Mot de passe de récupération',
  usertype: "Type d'utilisateur",
  Singlefunctioncarduser: 'Utilisateur de carte à fonction unique',
  vipcarduser: 'Utilisateur de la carte VIP',
  PTTGPS: 'PTT+GPS',
  PTTGPSuser: 'Utilisateurs PTT+GPS',
  display: "Afficher le nom d'utilisateur",
  Service_card_display: 'Affichage de la carte de service',
  RequiredvoiceserviceorVIPservice: 'Service PTT ou service VIP requis',
  is_card: {
    ptt: 'PTT',
    recording: 'Enregistrement',
    gps: 'GPS',
    sos: 'SOS',
    bounding: 'Limites',
    duplex: 'Duplex',
    vip: 'VIP'
  },
  Dispatcherrole: 'Rôle de répartiteur',
  show: 'montrer',
  point: 'Appel point à point',
  IMEIchange: "Changement d'IMEI",
  Register:"S'inscrire",
  Bindingdevice:"Appareil lié",
  Notactivated:"Non activée",
  Platformcreation:"Création de plateforme",
  Userregistration:"Enregistrement d'utilisateur",
  Binding:"Suppression",
  Notenabled:"Non activée",
  Unbinding:"Suppression",
  userPatrol:{
    PatrolCard: "Carte de patrouille",
    Patrol: "Patrouille",
    DisplayPatrolCard: "Afficher la carte de patrouille",
    GuardCardRecycling: "Recyclage des cartes de garde",
    patrolService:"service de patrouille",
    ConsumePatrolCards: "Consommez des cartes de patrouille",
    StartPatrolService: "Début du service de patrouille",
    YourPatrolCardIsInsufficientPleaseRecharge: "Votre carte de patrouille est insuffisante, veuillez la recharger !",
    UsingPatrolCards: "Utilisation des cartes de patrouille",
    PatrolCardBalanceInsufficient: "Solde insuffisant sur la carte de patrouille",
    PatrolServiceCard: "Carte de service de patrouille",
    PatrolCardSales: "Ventes de cartes de patrouille",
    PatrolFunctionNotification: "Notification de fonction de patrouille",
    PatrolManagement: "Gestion des patrouilles",
    PatrolPlan: "Plan de patrouille",
    ExecuteTheTask: "Exécutez la tâche",
    PatrolReport: "Rapport de patrouille",
    SearchPlan: "Plan de recherche",
    Suspended: "Suspendu",
    Enabled: "Activé",
    NewPlans: "Nouveaux projets",
    TerminalReminderSettings: "Paramètres de rappel du terminal",
    ReminderRules: "Règles de rappel",
    ReminderTime: "Heure de rappel",
    NumberOfReminders: "Nombre de rappels",
    minute: "minute",
    note1:"Note:Si l'heure de rappel de début de patrouille est réglée sur30Minutes, rappelant aux utilisateurs2La prochaine fois. Ensuite, les utilisateurs participant à la patrouille...30Reçu la première minute1Un message de rappel vous sera envoyé avant le début.15Reçu la première minute2Le nombre de notifications de messages sera comptabilisé, et ainsi de suite.",
    PleaseEnterTheReminderTime: "Veuillez saisir l'heure du rappel.",
    PleaseEnterTheNumberOfReminders:"Veuillez saisir le nombre de rappels.",
    PleaseEnterANumberGreaterThanOrEqualTo20: "Veuillez saisir un nombre supérieur ou égal à 20.",
    PleaseEnterANumberLessThanOrEqualTo5: "Veuillez saisir un nombre inférieur ou égal à 5.",
    OperationSuccessful: "Opération réussie",
    NewPatrolPlan: "Nouveau plan de patrouille",
    PleaseEnterThePlanName: "Veuillez saisir le nom du forfait.",
    UsersWhoNeedPatrols: "Utilisateurs ayant besoin de patrouilles",
    OnlyRegularUsersWhoHaveActivatedThePatrolServiceCanPerformPatrols: "Seuls les utilisateurs réguliers ayant activé le service de patrouille peuvent effectuer des patrouilles.",
    EffectiveDateOfThePlan: "Date d'entrée en vigueur du plan",
    PlannedStatus: "État prévu",
    Week: "Semaine",
    DailyPatrolTime: "Temps de patrouille quotidien",
    TaskGenerationTime: "Temps de génération des tâches",
    AutomaticallyGenerateTheTimeForTheNextDaysScheduledTasksEveryDay:"Générer automatiquement chaque jour l'heure des tâches planifiées pour le lendemain.",
    patrolPoint:"point de patrouille",
    save:"sauvegarder",
    TheProjectNameAlreadyExists:"Le nom du projet existe déjà.",
    TheNameConsistsOf1To50CharactersIncludingChineseCharactersNumbersLettersAndSpecialSymbols:"Le nom se compose de 1 à 50 caractères, incluant des caractères chinois, des chiffres, des lettres et des symboles spéciaux.",
    PleaseSelectTheUserWhoNeedsToBePatrolled:"Veuillez sélectionner l'utilisateur qui doit être surveillé.",
    PleaseSelectTheEffectiveDateOfThePlan:"Veuillez sélectionner la date d'entrée en vigueur du régime.",
    PleaseSelectDailyPatrolTime: "Veuillez sélectionner la durée de patrouille quotidienne.",
    TheEndTimeMustBeGreaterThanTheStartTime: "L'heure de fin doit être postérieure à l'heure de début.",
    PleaseSelectTheTaskGenerationTimeForTheNextDay: "Veuillez sélectionner l'heure de génération de la tâche pour le lendemain.",
    PleaseAddPatrolPoints: "Veuillez ajouter des points de patrouille.",
    PatrolUsers:"utilisateurs de Patrol",
    AddUser: "Ajouter un utilisateur",
    ConfirmAdd: "Confirmer l'ajout",
    PleaseSelectTheUserYouWishToAdd: "Veuillez sélectionner l'utilisateur que vous souhaitez ajouter.",
    UserAddedSuccessfully:"Utilisateur ajouté avec succès",
    AddTo: "Ajouter à",
    PatrolPointNames:"Noms des points de patrouille",
    PleaseEnterThePatrolPointName:"Veuillez saisir le nom du point de patrouille.",
    RequiredTheNameMustConsistOf1To50CharactersIncludingChineseCharactersNumbersLettersAndSpecialSymbols: "(Obligatoire : le nom doit comporter entre 1 et 50 caractères, incluant des caractères chinois, des chiffres, des lettres et des symboles spéciaux)",
    NFCNumber: "numéro NFC",
    PleaseEnterYourNFCNumber: "Veuillez saisir votre numéro NFC.",
    Required150Characters:"(Obligatoire : 1 à 50 caractères)",
    ThePatrolPointNameAlreadyExists: "Le nom du point de patrouille existe déjà.",
    TheNameConsistsOf150CharactersIncludingChineseCharactersNumbersLettersAndSpecialSymbols: "Le nom se compose de 1 à 50 caractères, incluant des caractères chinois, des chiffres, des lettres et des symboles spéciaux.",
    Remark: "Remarque",
    NoteWithin100Characters: "Remarque : Moins de 100 caractères",
    CreationSuccessful: "Création réussie",
    EditorsPatrolPoint: "Point de patrouille du rédacteur en chef",
    save1: "sauvegarder",
    ModificationSuccessful: "Modification réussie",
    delete: "supprimer",
    Remove: "Retirer",
    AreYouUreYouWantToDeleteThisPatrolPoint: "Êtes-vous sûr de vouloir supprimer ce point de patrouille ?",
    DeletionSuccessful: "Suppression réussie",
    EditorsPatrolPlan: "Plan de patrouille du rédacteur en chef",
    PatrolPlanDetails: "Détails du plan de patrouille",
    AreYouSureYouWantToSuspendThePlanIfSuspendedTodaysScheduledPatrolsWillBeCancelled: "Êtes-vous sûr de vouloir suspendre le plan ? En cas de suspension, les patrouilles prévues aujourd’hui seront annulées.",
    OperationSuccessful1: "Opération réussie",
    PleaseSelectTime: "Veuillez sélectionner une heure",
    FullPlan: "Plan complet",
    AllUsers:"Tous les utilisateurs",
    ProjectName:"Nom du projet",
    PatrolUsers1: "utilisateurs de Patrol",
    PatrolTime: "Temps de patrouille",
    NotStarted: "Pas encore commencé",
    inProgress: "en cours",
    Completed: "Complété",
    MissedInspection: "Inspection manquée",
    PleaseEnterYourUsername: "Veuillez saisir votre nom d'utilisateur.",
    ExecutionDetails: "Détails d'exécution",
    PatrolPointNames1: "Noms des points de patrouille",
    PatrolYype: "Type de patrouille",
    ExecutionResult: "Résultat de l'exécution",
    position: "position",
    NFC: "NFC",
    Bluetooth: "Bluetooth",
    PleaseSelectPatrolUser: "Veuillez sélectionner l'utilisateur de patrouille",
    DailyStatistics: "Statistiques quotidiennes",
    WeeklyStatistics: "Statistiques hebdomadaires",
    MonthlyStatistics: "Statistiques mensuelles",
    time: "temps",
    NumberOfPlannedExecutions: "Nombre d'exécutions prévues",
    ActualNumberOfExecutions: "Nombre réel d'exécutions",
    NumberOfMissedInspections: "Nombre d'inspections manquées",
    CompletionRate: "Taux d'achèvement",
    PleaseEnterYourUsername : "Veuillez saisir votre nom d'utilisateur.",
    Existing: "Existant",
    NewPatrolPoints:"Nouveaux points de patrouille"

  },
  minute:'minute',
  Reclaim:'Récupérer',
}
